import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Components/Table";
import FiltroAgendamentosComunicadosPorAudiencia from "./FiltroAgendamentosComunicadosPorAudiencia";
import { useState } from "react";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import ModalComponent from "../../../Components/Modais";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import {
    AtualizarAgendamentosComunicadosController,
    DeletarAgendamentoComunicadoController,
    ListarAgendamentoComunicadoController,
} from "../../../Controllers/Automacao/Audiencia/AudienciaControllers";
import {
    IAgendamentosComunicadosRequest,
    IAgendamentosComunicadosResponse,
} from "../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import Swal from "sweetalert2";
import ComunicadoEmMassa from "../GestaoAudiencia/ComunicadoEmMassa";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import VisualizarLogsDisparoComunicadoAgendados from "./VisualizarLogsDisparoComunicadoAgendados";

const filtroInicial: IAgendamentosComunicadosRequest = {
    ID_PAGINA: 1,
    QUANTIDADE: 10,
    DT_INICIAL: "",
    DT_FIM: "",
    ID_AUDIENCIA: undefined,
    ID_USUARIO: 0,
    FL_EXECUTADO: undefined,
};

export default function AgendamentosComunicadosPorAudiencia() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const FILTRO_AGENDAMENTO_AUDIENCIA = sessionStorage.getItem(
        "FILTRO_AGENDAMENTO_AUDIENCIA"
    );

    const { PageFilter, filter, setFilter, setPage } =
        usePaginationFilter<IAgendamentosComunicadosRequest>({
            page: 1,
            filter: FILTRO_AGENDAMENTO_AUDIENCIA
                ? JSON.parse(FILTRO_AGENDAMENTO_AUDIENCIA)
                : filtroInicial,
        });

    const {
        value: lstAgendamentosComunicados,
        loading: lstAgendamentosComunicadosLoading,
        execute: updateList,
    } = useAsyncEffect(async () => {
        if (PageFilter.filter) {
            return ListarAgendamentoComunicadoController(
                PageFilter.page ?? 0,
                10,
                {
                    ...PageFilter.filter,
                    DT_FIM: PageFilter.filter.DT_FIM
                        ? PageFilter.filter.DT_FIM
                        : undefined,
                    DT_INICIAL: PageFilter.filter.DT_INICIAL
                        ? PageFilter.filter.DT_INICIAL
                        : undefined,
                    FL_EXECUTADO:
                        String(PageFilter.filter.FL_EXECUTADO) === "1"
                            ? true
                            : String(PageFilter.filter.FL_EXECUTADO) === "0"
                            ? false
                            : undefined,
                    ID_AUDIENCIA: PageFilter.filter.ID_AUDIENCIA
                        ? PageFilter.filter.ID_AUDIENCIA
                        : undefined,
                    ID_USUARIO: PageFilter.filter.ID_USUARIO
                        ? PageFilter.filter.ID_USUARIO
                        : undefined,
                }
            );
        }
    }, [PageFilter]);

    const totalPaginas = lstAgendamentosComunicados?.[0]?.NR_PAGINA;

    const {
        execute: AtualizarAgendamentosComunicados,
        loading: AtualizarAgendamentosComunicadosLoading,
    } = useAsyncCallback(AtualizarAgendamentosComunicadosController);

    const {
        execute: DeletarAgendamentoComunicado,
        loading: DeletarAgendamentoComunicadoLoading,
    } = useAsyncCallback(DeletarAgendamentoComunicadoController);

    const columns: Array<ColumnDescription<IAgendamentosComunicadosResponse>> =
        [
            {
                dataField: "DS_TIPO_COMUNICADO",
                text: "Tipo de Comunicado",
                classes: "p-2",
            },
            {
                dataField: "DS_DOCUMENTO_TEMPLATE",
                text: "Template Utilizado",
                classes: "p-2",
            },
            { dataField: "DS_ASSUNTO", text: "Assunto", classes: "p-2" },
            {
                dataField: "audiencias",
                text: "Audiências",
                classes: "p-2",
                formatter: (c, row) =>
                    row.Audiencias?.length
                        ? row.Audiencias.map(
                              (audiencia) => audiencia.DS_AUDIENCIA
                          ).join(", ")
                        : "Nenhuma audiência",
            },

            {
                dataField: "DT_AGENDAMENTO",
                text: "Data de Agendamento",
                classes: "p-2",
                formatter: (c, row) => {
                    return (
                        <>{c ? moment(c).format("DD/MM/YYYY HH:mm") : "-"}</>
                    );
                },
            },
            {
                dataField: "DS_USUARIO",
                text: "Usuário de Cadastro",
                classes: "p-2",
            },
            {
                dataField: "DT_CADASTRO",
                text: "Data de Criação",
                classes: "p-2",
                formatter: (c, row) => {
                    return (
                        <>{c ? moment(c).format("DD/MM/YYYY HH:mm") : "-"}</>
                    );
                },
            },
            {
                dataField: "FL_EXECUTADO",
                text: "Executado?",
                classes: "p-2",
                formatter: (c) => (c ? "Sim" : "Não"),
            },
            {
                dataField: "Editar",
                text: "Editar",
                formatter: (cell, row) => (
                    <div className="d-flex justify-content-center">
                        {!row.FL_EXECUTADO && (
                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () => (
                                            <ComunicadoEmMassa
                                                setModal={setShow}
                                                updateList={updateList}
                                                lstAudiencia={row.Audiencias}
                                                row={row}
                                                AtualizarAgendamentosComunicados={
                                                    AtualizarAgendamentosComunicados
                                                }
                                            />
                                        ),
                                        noFooter: true,
                                        size: "lg",
                                        noHeader: true,
                                    });
                                }}
                                disabled={
                                    DeletarAgendamentoComunicadoLoading ||
                                    AtualizarAgendamentosComunicadosLoading
                                }
                            >
                                {AtualizarAgendamentosComunicadosLoading ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <FontAwesomeIcon icon={faEdit} />
                                )}
                            </button>
                        )}
                    </div>
                ),
            },
            {
                dataField: "Deletar",
                text: "Deletar",
                formatter: (cell, row) => (
                    <div className="d-flex justify-content-center">
                        {!row.FL_EXECUTADO && (
                            <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja realmente deletar esse agendamento?",
                                        showCancelButton: true,
                                        confirmButtonText: "Sim",
                                        cancelButtonText: "Não",
                                        icon: "warning",
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarAgendamentoComunicado(
                                                row.ID_COMUNICADO_AGENDAMENTO
                                            ).then(() => {
                                                setPage(1);
                                                updateList();
                                            });
                                        }
                                    });
                                }}
                                disabled={
                                    DeletarAgendamentoComunicadoLoading ||
                                    AtualizarAgendamentosComunicadosLoading
                                }
                            >
                                {DeletarAgendamentoComunicadoLoading ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <FontAwesomeIcon icon={faTrash} />
                                )}
                            </button>
                        )}
                    </div>
                ),
            },
            {
                dataField: "Visualizar",
                text: "Visualizar",
                formatter: (cell, row) => (
                    <div className="d-flex justify-content-center">
                        {row.FL_EXECUTADO && (
                            <button
                                className="btn btn-sm btn-outline-info"
                                disabled={
                                    DeletarAgendamentoComunicadoLoading ||
                                    AtualizarAgendamentosComunicadosLoading
                                }
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () => (
                                            <VisualizarLogsDisparoComunicadoAgendados
                                                row={row}
                                            />
                                        ),
                                        noFooter: true,
                                        size: "lg",
                                        noHeader: true,
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEye} />
                            </button>
                        )}
                    </div>
                ),
            },
        ];

    return (
        <div className="card card-body p-5">
            <h1>Agendamentos de Comunicados</h1>
            <Table
                key={`ID_COMUNICADO_AGENDAMENTO ${DeletarAgendamentoComunicadoLoading} ${AtualizarAgendamentosComunicadosLoading}`}
                keyField="ID_COMUNICADO_AGENDAMENTO"
                columns={columns}
                data={lstAgendamentosComunicados || []}
                noSearch
                onTableChange={(type, newState) => {
                    setPage(newState.page);
                }}
                remote={{ pagination: true }}
                loading={lstAgendamentosComunicadosLoading}
                totalPages={totalPaginas}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Agendamento encontrado
                    </div>
                )}
            />

            <FiltroAgendamentosComunicadosPorAudiencia
                filter={filter}
                filtroInicial={filtroInicial}
                setFilter={setFilter}
                FILTRO_AGENDAMENTO_AUDIENCIA={FILTRO_AGENDAMENTO_AUDIENCIA}
            />
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
